import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { statusStyles } from './styles';
import { StatusValue } from '@/shared';

interface StatusProps {
  status: StatusValue;
}

export const Status = ({ status }: StatusProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={twMerge(
        'flex h-8 items-center rounded-[3px] bg-gray-100 px-2.5 py-[5px] text-sm font-bold',
        statusStyles(status),
      )}
    >
      <span>{t(`status.${StatusValue[status]}`)}</span>
    </div>
  );
};
